import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appTableHeader]',
  standalone: false,
})
export class TableHeaderDirective {
  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public templateRef: TemplateRef<any>,
  ) {}
}
